
(function MaxxIntelligenceHistory($, Adzuki)
{
	"use strict";

	var $modal  = $('.modal');

	$(document).ready(function documentReady()
	{
		Adzuki.onload('Ai/maxxIntelligenceHistory', function onload() {
			$('.maxx-intelligence-copy').on('click', function _copyHistoryToClipboard(e) {
				var content = $(this).data('content');

				e.preventDefault();

				copyToClipboard(content);
			});

			$modal.on('click', '.history-copy', function onClick(e) {
				var content = $(this).data('content');

				e.preventDefault();

				copyToClipboard(content);
			});

			$modal.on('click', '.history-snippets', function onClick(e) {
				var content = $(this).data('content');

				e.preventDefault();

				sendToSnippets(content);
			});

			$('.maxx-intelligence-history').on('click', function onClick(e) {
				var interactionId    = $(this).data('id'),
					searchTerm        = $(this).data('search-term');

				e.preventDefault();

				$modal.find('.modal-title').text("Maxx Intelligence");
				Adzuki.Ajax.get('/Ai/maxxIntelligenceDetails/' + interactionId + '/' + searchTerm).then(function success(html) {
					$modal.find('.modal-body').html(html);
				});

				$modal
					.addClass('history-modal') // Add a class to adjust width
					.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('history-modal').removeClass('wide').off('hidden.bs.modal');
					})
					.on('shown.bs.modal', function _adjustModalHeight() {
						setModalMaxHeight();
					})
					.modal('show');

				// Call setModalMaxHeight on window resize
				$(window).on('resize', setModalMaxHeight);
			});
		});
	});

	function copyToClipboard(text) {
		// Create a temporary element
		var tempElement = document.createElement('div');
		var range;
		var selection;

		tempElement.innerHTML = text;
		tempElement.setAttribute('style', 'position: absolute; left: -9999px;');
		document.body.appendChild(tempElement);

		// Select the text
		range = document.createRange();
		range.selectNodeContents(tempElement);
		selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(range);

		// Try to copy
		try {
			if (document.execCommand('copy')) {
				Adzuki.StatusMessage('Success', 'Response copied to clipboard');
			} else {
				throw new Error('Copy command failed');
			}
		} catch (err) {
			console.error('execCommand Error:', err);

			// Fallback to Clipboard API
			if (navigator.clipboard && navigator.clipboard.writeText) {
				navigator.clipboard.writeText(text).then(function _writeText() {
					Adzuki.StatusMessage('Success', 'Response copied to clipboard');
				}).catch(function _clipboardError(clipboardErr) {
					console.error('Clipboard API Error:', clipboardErr);
					Adzuki.StatusMessage('Error', 'Failed to copy response to clipboard');
				});
			} else {
				Adzuki.StatusMessage('Error', 'Failed to copy response to clipboard');
			}
		} finally {
			// Clean up
			selection.removeAllRanges();
			document.body.removeChild(tempElement);
		}
	}

	function sendToSnippets(content)
	{
		Adzuki.Ajax.post('/Ai/saveSnippet/', {snippet: content.trim()}).then(function success(content) {
			Adzuki.StatusMessage('Success', 'Saved to your Snippets');
		});
	}

	function setModalMaxHeight()
	{
		var windowHeight = $(window).height();
		var modalHeader = $modal.find('.modal-header').outerHeight() || 0;
		var modalFooter = $modal.find('.modal-footer').outerHeight() || 0;
		var modalBodyPadding = parseInt($modal.find('.modal-body').css('padding-top'), 10)
								+ parseInt($modal.find('.modal-body').css('padding-bottom'), 10);

		var maxHeight = windowHeight - modalHeader - modalFooter - modalBodyPadding - 60; // 20px for some margin
		$modal.find('.modal-body').css('max-height', maxHeight + 'px');
	}
}(jQuery, window.Adzuki || {}));